import { render, staticRenderFns } from "./UnsignedLessonsNotice.vue?vue&type=template&id=e2baff6e&scoped=true"
import script from "./UnsignedLessonsNotice.vue?vue&type=script&lang=js"
export * from "./UnsignedLessonsNotice.vue?vue&type=script&lang=js"
import style0 from "./UnsignedLessonsNotice.vue?vue&type=style&index=0&id=e2baff6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2baff6e",
  null
  
)

export default component.exports